//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TooltipColumn from '@/components/tooltipColumn';

export default {
  components: { TooltipColumn },
  props: {
    request: {
      type: Function,
      default: undefined,
      require: true,
    },
    layout: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      list: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    resetPage() {
      this.pageIndex = 1;
      this.pageSize = 10;
    },
    getList() {
      this.request({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }).then(({ list, total }) => {
        this.list = list;
        this.total = Number(total);
      });
    },
    // 分页器
    handleSizeChange(value) {
      this.pageIndex = 1;
      this.pageSize = value;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
  },
};
